import { action, computed, makeObservable, observable } from 'mobx';

export enum Instruments {
  BUFFER_ZONE,
  GO_TO_COORDINATE,
  HEATMAP,
  ROAD_SEGMENT,
  ROUTE,
  CARTOGRAMS,
  WHAT_IS_HERE,
}

export class InstrumentMenuController {
  // TODO: Без присваивания значения переменной рендера не будет. Похоже на баг mobx. Возможно стоит обновить mobx (Сейчас используется 6.3.13. Поведение в mobx 6.3.2 не воспроизводится).
  @observable private _activeInstrument?: Instruments = undefined;

  constructor() {
    makeObservable<InstrumentMenuController>(this);
  }

  @computed get activeInstrument() {
    return this._activeInstrument;
  }

  @action open = (instrument: Instruments) => {
    if (this._activeInstrument === instrument) return;

    this._activeInstrument = instrument;
  };

  @action close = () => {
    this._activeInstrument = undefined;
  };
}
